import React from "react";
import { observer } from "mobx-react";
import { MediaItemDetailsScreen } from "./MediaItemDetailsScreen";

export const ResourceDetailsScreen: React.FC<any> = observer((props) => (
  <MediaItemDetailsScreen />
));
